// extracted by mini-css-extract-plugin
export default {"editable":"Rating_editable__zot6X","wrapper":"Rating_wrapper__tpBDF"};